module.exports = __webpack_public_path__ + "media/images/basic_logos/customer_receipt_logo-19cece247c9a5cedad3eca071724cdb3.png";